module.exports = __webpack_public_path__ + "img/top_slider_bodymilk.6c4924c4.jpg";